<template>
  <div class="confirm-order">
    <!-- 确认订单页 -->
    <!-- 引入公共头部 :showBack="true" :showEdit="true"-->
    <dg-header :showBack="true" title="确认订单"></dg-header>
    <div class="confirm-order-wrap">
      <!-- 如果是团购商品显示拼团成员信息 -->
      <div class="group-bulk" v-if="orderDetails.buyType === 2">
        <p class="group-bulk-title">
          <span class="group-bulk-state">【{{orderDetails.join === 1 ? '正在开团' : '拼团中'}}】</span> 
          {{orderDetails.join === 1 ? '完成支付，即可开团成功' : '完成支付，即可拼团'}}
          </p>
        <ul class="group-bulk-ul">
           <!--参团展示-->
          <li class="group-bulk-li" v-for="(userItem, i) in orderDetails.groupOrder_doc[0].userInfo" :key="i" v-if="orderDetails.join === 2">
            <span class="group-bulk-span default-photo">
              <img :src="userItem.portrait" alt="">
            </span>
            <p class="group-bulk-p">{{userItem.nickName}}</p>
          </li>
           <!--开团展示-->
          <li class="group-bulk-li open-group">
            <span class="group-bulk-span default-photo">
              <!-- <img src="@/assets/images/disable-reduce-icon.png" alt=""> -->
            </span>
            <p class="group-bulk-p">待支付</p>
          </li>
        </ul>
      </div>
      <!-- 商品信息，买家留言，商品金额 -->
      <div class="co-section" v-if="orderDetails.comInfoList">
        <!-- 商品信息 -->
        <div class="order-info" v-for="(item, i) in orderDetails.comInfoList"
          :key="i" >
          <!-- 商品图片 -->
          <div class="order-info-left dg-small-no-photo">
            <img :src="item.comImage" alt>
          </div>
          <!-- 商品名，价格 -->
          <div class="order-info-middle">
            <p class="order-info-text">{{item.comName}}</p>
            <div class="attr-box">
              <span class="attr-item" v-for="(attrItem, index) in item.attribute" :key="index">
                {{attrItem.name + ':' + attrItem.value}}
              </span>
            </div>
            <p class="order-info-price">
              <span class="fs24">JPY</span> {{item.price  | setNumber}}
            </p>   
          </div>
          <!-- 数量 -->
          <div class="order-info-right">x {{item.count || 0}}</div>
        </div>
        <!-- 留言区域 -->
        <div class="remark-wrap">
          <textarea class="remark-textarea" name id rows="3" placeholder="买家留言(50字以内)" v-model="orderParams.remark" maxlength="50"></textarea>
        </div>
        <!-- 支付方式,商品金额 -->
        <div class="pay-method-wrap">
          <div class="pay-method-item goods-amount">
            <p class="text">商品金额</p>
            <p class="goods-price">
              <span class="fs24">JPY</span> {{orderDetails.totalCost | setNumber}}
            </p>
          </div>
          <div class="pay-method-item pay-method">
            <p>支付方式</p>
            <div class="payment-wrap">
              <span class="payment-mode text">信用额度</span>
              <van-icon class="skip-arrow" name="arrow" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部提交订单按钮 -->
    <div class="confirm-order-footer">
      <div class="footer-head">
        <p class="footer-text">合计:</p>
        <p class="footer-price">
          <span class="fs24">JPY</span> {{orderDetails.totalCost  | setNumber}}
        </p>
      </div>
      <van-button round @click="createOrder">提交订单</van-button>
    </div>
  </div>
</template>
<script>
import DgHeader from "@/components/header";
import api from '@/server'
export default {
  data() {
    return {
      orderParams: {
        cartList: [],
        userId: localStorage.getItem("userInfo")
          ? JSON.parse(localStorage.getItem("userInfo"))._id
          : "",
        payType: '1',
        remark: '',
        totalCost: '',
        tempOrderNumber: '',
        type: 'NORAM',
        tempGroupOrderNumber: '', // 临时团单编号
        buyType: '',
        join: ''
      },
      orderDetails: {}
    };
  },
  components: {
    DgHeader
  },
  created() {
    this.getOrderDetails()
  },
  methods: {
    // 根据id查询订单详情
    getOrderDetails() {
      api.getOrderDetails({
        orderNumber: this.$route.query.id,
        type: 'TEMP'
      }).then(res=> {
        if(res.code === 200 && res.data) {
          this.orderDetails = res.data
          this.orderParams.tempOrderNumber = res.data.orderNumber;
        } else {
          this.orderDetails = {}
        }
      }).catch(err=> {
        console.log(err)
      })
    },
    // 生成正式订单
    createOrder() {
      this.orderParams.cartList = this.orderDetails.comInfoList;
      this.orderParams.totalCost = this.orderDetails.totalCost;
      this.orderParams.tempGroupOrderNumber = this.orderDetails.groupOrderNumber;
      this.orderParams.buyType = this.orderDetails.buyType;
      this.orderParams.join = this.orderDetails.join;
      api.createOrder(this.orderParams).then(res=> {
       if(res.code === 200 && res.data) {
         // 清除本地购物车数据
         if (this.$route.query.type === 'car') {
           let data = JSON.parse(localStorage.getItem('carList'))
           this.orderParams.cartList.forEach(item=> {
             data.forEach((dataItem, i)=> {
               if(dataItem._id === item.cartId) {
                 data.splice(i, 1)
               }
             })
           });
           localStorage.setItem('carList', JSON.stringify(data));
           this.$store.dispatch('setCarNumber', data.length);
         }
         this.$router.replace({
           name: 'payment',
           query: {
             id: res.data.orderNumber,
             totalCost: res.data.totalCost
           }
         })
       } else {
         this.$toast.fail('提交订单失败')
       }
      }).catch(err=> {
        console.log(err)
      })
    }
  }
};
</script>
<style lang="scss" >
.confirm-order {
  padding-top: 88px;
  .fs24 {
    font-size: 24px;
  }
  // 公共右箭头
  .skip-arrow {
    font-size: 38px;
    color: $fc01;
    font-weight: 600;
  }
  .text {
    font-size: 28px;
    color: $fc06;
  }
  .confirm-order-wrap {
    width: 100%;
    height: auto;
    padding: 30px 30px 100px 30px;
    box-sizing: border-box;
    // 选择收货地址部分
    .select-addr-con {
      .select-addr {
        // height: 80px;
        width: 100%;
        padding: 20px 30px;
        box-sizing: border-box;
        background: $bg02;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .flex-rwap {
          display: flex;
          align-items: center;
          text-align: right;
          > span {
            width: 40px;
            height: 40px;
            display: inline-block;
            margin-right: 24px;
            > img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          > p {
            font-size: 26px;
            color: $fc03;
          }
        }
        .nomal-flex {
          flex: 1;
          overflow: hidden;
          .name-text {
            font-size: 28px;
            color: $fc03;
            > span {
              font-size: 26px;
              color: $fc09;
              margin-left: 8px;
            }
          }
          .addr-text {
            @include ellipsis();
            font-size: 24px;
            color: $fc09;
            margin-top: 10px;
          }
        }
        &:active .skip-arrow {
          color: $fc09;
        }
      }
      // 添加联系人
      .van-contact-card {
        padding: 10px 30px;
        &::before {
          background: none;
          height: 0;
        }
        .van-icon-add-square.van-cell__left-icon {
          width: 40px;
          height: 40px;
          display: inline-block;
          font-size: inherit !important;
          background: url("../../../assets/images/add-addredd-icon.png")
            no-repeat 0 0/100%;
        }
        .van-icon-contact.van-cell__left-icon {
          display: none;
        }
        .van-icon-add-square:before {
          content: "";
        }
        .van-cell__right-icon {
          font-size: 38px;
          color: $fc01;
          font-weight: 600;
        }
      }

      .van-popup--bottom {
        top: 0;
      }
    }
    /*如果是团购商品显示拼团成员信息*/
    .group-bulk{
      background: $bg02;
      padding: 30px;
      border-radius: $br30;
      box-shadow: $box-shadow3;
      margin-bottom: 8px;
      .group-bulk-title{
        .group-bulk-state{
          color: $fc04;
        }
      }
      .group-bulk-ul{
        display: table;
        text-align: center;
        margin: 0 auto;
        margin-top: 10px;
        .open-group{
          color: $fc04;
          .group-bulk-span{
            border: 2px solid $fc04;
          }
        }
        .group-bulk-li{
          width: 80px;
          margin-right: 30px;
          float: left;
          margin-top: 15px;
          .group-bulk-span{
            display: inline-block;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            overflow: hidden;
            >img{
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .group-bulk-p{
            text-align: center;
            font-size: 24px;
            @include ellipsis();
          }
        }
      }
    }
    // 商品信息，买家留言，商品金额
    .co-section {
      // width: 100%;
      // height: auto;
      // padding: 30px 30px 0 30px;
      // box-sizing: border-box;
      .order-info,
      .remark-wrap,
      .pay-method-wrap {
        background: $bg02;
        padding: 30px;
        border-radius: $br30;
        box-shadow: $box-shadow3;
        margin-bottom: 8px;
      }
      // 商品信息
      .order-info {
        display: flex;
        // margin: 16px 0;
        .order-info-left {
          width: 150px;
          height: 160px;
          border: 1px solid $bc01;
          border-radius: $br20;
          overflow: hidden;
          margin-right: 24px;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border: none;
            outline: none;
          }
        }
        .order-info-middle {
          flex: 1;
          overflow: hidden;
          margin-right: 10px; 
          .order-info-text {
            font-size: 28px;
            color: $fc06;
            margin-bottom: 10px;
            @include moreEllipsis(2);
          }
          .order-info-price {
            font-size: 30px;
            color: $fc04;
          }
          .attr-box{
            width: 100%;
            min-height: 60px;
            // display: flex
          }
          .attr-item{
            max-width: 180px;
            background: $bg01;
            padding: 6px 10px;
            margin-top: 4px;
            display: inline-block;
            justify-content: space-between;
            align-items: center;
            margin-right: 20px;
            color: $fc09;
            @include ellipsis();
          }
        }
        .order-info-right {
          font-size: 32px;
          color: $fc06;
          flex-shrink: 0;
          line-height: 160px;
        }
      }
      // 买家留言
      .remark-textarea {
        width: 100%;
        border: none;
        color: $fc06;
        font-size: 24px;
        resize: none;
        height: auto;
      }
    }

    // 支付方式，商品金额
    .pay-method-item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 70px;
      > p {
        font-size: 28px;
        color: $fc09;
      }
      .goods-price {
        color: $fc06;
        margin-right: 50px;
      }
    }
    .goods-amount {
      border-bottom: 2px solid $bc04;
    }
    .payment-wrap {
      display: flex;
      align-items: center;
      .payment-mode {
        margin-right: 15px;
      }
    }
    // 合计金额
    .total-sum-wrap {
      text-align: right;
      font-size: 30px;
      color: $fc03;
      width: 100%;
      padding: 0 40px;
      box-sizing: border-box;
      margin-top: 50px;
      > span {
        font-size: 36px;
        color: $fc04;
      }
    }
  }
  // 底部提交订单按钮
  .confirm-order-footer {
    width: 100%;
    max-width: 750px;
    height: 98px;
    padding: 9px 30px;
    box-sizing: border-box;
    background: $bg02;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .footer-head {
      text-align: right;
      .footer-text {
        font-size: 26px;
        color: $fc06;
      }
      .footer-price {
        font-size: 32px;
        color: $fc04;
      }
    }
    .van-button {
      width: 210px;
      height: 80px;
      text-align: center;
      line-height: 80px;
      background: $bg05;
      color: $fc02;
      font-size: 28px;
      margin-left: 20px;
      @include resetButton();
    }
  }
}
</style>
